import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  List,
  ResourceContextProvider,
  SearchInput,
  TextField,
  useDataProvider,
} from "react-admin";
import CustomPriceField from "components/CustomPriceField";
import { availableOnlySuperAdminAndCustomerServices } from "utils/validation";
import RegeneratePdfButton from "./RegeneratePdfButton";
import TaggingCreditNoteButton from "./TaggingCreditNoteButton";

interface IApproveUntaggedCreditNotesTable {
  customerId: number;
}

const ApproveUntaggedCreditNotesTable = ({
  customerId,
}: IApproveUntaggedCreditNotesTable) => {
  const provider = useDataProvider();

  const GetPdf = (id: number) => {
    provider
      .getOne("creditNotes", {
        id: id,
      })
      .then(({ data }) => {
        window.open(data.pdfUrl, "_blank");
      });
  };

  const ShowPdfButton = (props: any) => {
    return (
      <>
        {props.data.pdfUrl !== null && (
          <>
            <Button
              onClick={() => {
                GetPdf(props.data.id);
              }}
              label="Show PDF"
            />
          </>
        )}
        <RegeneratePdfButton accountingDocumentNumber={props.data.number} />
      </>
    );
  };

  const CreditNotesFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
    </Filter>
  );

  return (
    <ResourceContextProvider value="creditNotes">
      <List
        basePath="/creditNotes"
        exporter={false}
        hasCreate={false}
        actions={null}
        filters={<CreditNotesFilter />}
        filterDefaultValues={{
          CustomerId: customerId,
          Status: "posted",
          IsTagged: false,
        }}
        sort={{ field: "createdAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
      >
        <Datagrid>
          <TextField
            label="Credit Notes Number"
            source="number"
            emptyText="-"
          />

          <TextField label={"Type Credit Note"} source="label" emptyText="-" />
          <TextField
            label={"Description"}
            source="items[0].description"
            emptyText="-"
          />
          <CustomPriceField label="Amount" source="subTotal" />
          <CustomPriceField label="Amt. Include VAT" source="total" />

          <FunctionField
            label="Action"
            render={(record: any) => {
              return (
                <>
                  {availableOnlySuperAdminAndCustomerServices() && (
                    <TaggingCreditNoteButton
                      selectedCreditNote={record}
                      customerId={customerId}
                    />
                  )}

                  <ShowPdfButton data={record} />
                </>
              );
            }}
          />
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

export default ApproveUntaggedCreditNotesTable;
